import { HouseIcon, MapPinIcon, PersonIcon, StorefrontIcon } from '@phosphor-icons/react'

export const deliveryMethodIcons = {
  customerdelivers: <PersonIcon size={20} />,
  customerpickup: <HouseIcon size={20} />,
  returntostore: <StorefrontIcon size={20} />,
  pickuppoint: <MapPinIcon size={20} />,
}
